// extracted by mini-css-extract-plugin
export var change = "_38-1";
export var changeList = "_38-0";
export var changePath = "_38-2";
export var diffArrow = "_38-5";
export var diffRow = "_38-3";
export var diffValue = "_38-4";
export var error = "_38-8";
export var notice = "_38-9";
export var result = "_38-6";
export var success = "_38-7";